<template>
    <div class="pt-[38px] mb-6 text-xl font-semibold">
        {{ $t('customer.sidebar.title') }}
    </div>
    <div class="flex flex-col items-start text-base-content-subtle text-sm font-normal">
        <MiscLink to="/customer" class="w-auto py-2 hover:underline hover:text-primary" active-class="text-primary font-semibold">
            {{ $t('customer.sidebar.index') }}
        </MiscLink>
        <MiscLink to="/customer/orders" class="w-auto py-2 hover:underline hover:text-primary" active-class="text-primary font-semibold">
            {{ $t('customer.sidebar.orders') }}
        </MiscLink>
        <MiscLink to="/customer/account" class="w-auto py-2 hover:underline hover:text-primary" active-class="text-primary font-semibold">
            {{ $t('customer.sidebar.account') }}
        </MiscLink>
        <MiscLink to="/customer/addresses" class="w-auto py-2 hover:underline hover:text-primary" active-class="text-primary font-semibold">
            {{ $t('customer.sidebar.addresses') }}
        </MiscLink>
        <MiscLink to="/customer/wishlist" class="w-auto py-2 hover:underline hover:text-primary" active-class="text-primary font-semibold">
            {{ $t('customer.sidebar.wishlist') }}
        </MiscLink>
        <!-- Temporarily deactivated newsletter-subscribe link -->
        <!-- <MiscLink to="/newsletter-subscribe" class="w-auto py-2 hover:underline hover:text-primary" active-class="text-primary font-semibold">
            {{ $t('customer.sidebar.newsletter') }}
        </MiscLink> -->
        <button 
            data-cy="customerLogout" 
            type="button" 
            class="btn btn-sm btn-secondary mt-6" 
            @click="logout()"
        >
            <MiscIcon name="log-out" />
            {{ $t('customer.sidebar.logout') }}
        </button>
    </div>
</template>

<script setup lang="ts">
const { logout } = useUser()
</script>
